import { useEffect, useState } from "react";
import { endpoints } from "../utils/Constants";
import { mockUserData } from "../common/data/user.mock";

const USE_MOCK_DATA = false;

export type UserData = {
  id: string;
  userName: string;
  email: string | null;
  password: string | null;
  firstName: string;
  lastName: string;
  phonenumber: string | null;
  birthDate: string | null;
  isTellerUser: boolean | null;
  isVivaUser: boolean | null;
  culture: string;
  locale: string;
  profilePhoto: string | null;
  returnUrl: string | null;
  siteapp: string | null;
  country: string;
  siteCountry: string;
};

type UseUserDataResult = {
  userData: UserData | null;
  isLoggedIn: boolean;
  loading: boolean;
  error: string | null;
};

export function useUserData(): UseUserDataResult {
  const [userData, setUserData] = useState<UserData | null>(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (USE_MOCK_DATA) {
      setUserData(mockUserData);
      setIsLoggedIn(true);
      setLoading(false);
      return;
    }

    // Present only when the user is authenticated (server-rendered)
    const csrfToken = (
      document.getElementById(
        "__HD_RequestVerificationToken",
      ) as HTMLInputElement
    )?.value;

    if (!csrfToken) {
      setIsLoggedIn(false);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    fetch(endpoints.user.getUser, {
      method: "GET",
      credentials: "include",
      headers: { Accept: "application/json", "x-csrf": csrfToken },
    })
      .then((res) => {
        if (res.status === 401 || res.status === 403) {
          setIsLoggedIn(false);
          return null;
        }
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (data) {
          setUserData(data);
          setIsLoggedIn(true);
        }
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return { userData, isLoggedIn, loading, error };
}
